import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter } from "@tabler/icons-react";
import Loading from "../../components/common/Loading";
import {
  getAttendenceData,
  getDepartments,
  getEmployee,
  getemployeewithshift,
  getShifEmployees,
  getShift,
  insertMarkAttendence,
  insetNewAttendence,
  unautheriseatttendance,
} from "../../services/dataService";
import FilterComponent from "../pages/FilterComponent";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import zIndex from "@mui/material/styles/zIndex";
import { useNavigate } from "react-router-dom";
import { getSecureItem } from "../../services/SecureStorage";

export default function Attendance() {
  const UID = getSecureItem("userId");

  const [AttendenceRecords, setAttendenceRecords] = useState([]);
  const [date, setDate] = useState(Date);
  const [loading, setLoading] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [shift, setShifs] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [showDepName, setShowDepName] = useState("");
  // const DepartmentId = getSecureItem("DepartmentId");
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepartmentId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  console.log(DepartmentId)
  const [employee, setEmployee] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [newInTime, setNewInTime] = useState("");
  const [newOutTime, setNewOutTime] = useState("");
  const [newshif, setnewshif] = useState("");
  const [newdep, setnewdep] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const handleDateChange = (e) => setDate(e.target.value);
  const [department, setDepartment] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({});
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [newemp, setnewemp] = useState([]);
  const [AddAttedenceData, setAddAttedenceData] = useState({
    Id: "",
    EmpId: "",
    ATTENDANCESTATUS: 1,
    Date: "",
    Shift: "",
    EmployeeName: "",
    InTime: "",
    OutTime: "",
    DeptId: "",
  });
  const handleEditClick = (rowId) => {
    const row = AttendenceRecords.find((record) => record.ID === rowId);
    if (row) {
      setEditingRow(row); // Set the current row being edited
      setNewInTime(row.INTIME ? row.INTIME.split("T")[1]?.slice(0, 5) : "");
      setNewOutTime(row.OUTTIME ? row.OUTTIME.split("T")[1]?.slice(0, 5) : "");
      setnewshif(row.SHIFTID);
      setnewdep(row.DEPARTMENTID);
      setnewemp(row.EMPLOYEEID);
      setShowModal(true); // Show the modal
    }
  };

  useEffect(() => {
    console.log("AddAttedenceData", AddAttedenceData, employee);
  }, [AddAttedenceData]);

  const departmentoption = department.map((el) => {
    return { value: el.Id, label: el.Name };
  });

  // const employeeOption=employee.filter((el)=>el.ShiftId===AddAttedenceData.Shift).map({
  // return {value:el.Id,label:el.Name}

  // })

  const employeeOption = employee
    ?.filter((el) => {
      // Convert the ShiftId string into an array
      const shiftIds = el.ShiftId.split(",");
      // Check if AddAttedenceData.Shift is included in the array
      return shiftIds.includes(AddAttedenceData.Shift);
    })
    .map((em) => {

      return { value: em.Id, label: em.Name };
    });



  // Handle case when no employees match

  //check box working

  //end

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: "100",
    },
    content: {
      background: "white",
      padding: "20px",
      borderRadius: "8px",
      width: "400px",
      maxWidth: "100%",
    },
    inputField: {
      width: "100%",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      marginBottom: "10px",
    },
    button: {
      width: "48%",
      padding: "10px",
      borderRadius: "4px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    cancelButton: {
      backgroundColor: "#ccc",
      marginRight: "4%",
    },
    saveButton: {
      backgroundColor: "#28a745",
      color: "white",
    },
    cancelButtonHover: {
      backgroundColor: "#999",
    },
    saveButtonHover: {
      backgroundColor: "#218838",
    },
  };

  useEffect(() => {
    // Check if all rows have ATTENDANCESTATUS = 1
    const allApproved = AttendenceRecords.every(
      (row) => row.ATTENDANCESTATUS === 1
    );
    setIsAllSelected(allApproved); // If all have ATTENDANCESTATUS = 1, set "Select All" as checked
  }, [AttendenceRecords]);
  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const responses = await getDepartments(UID);
        setDepartment(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchProfitCenters();
  }, []);

  useEffect(() => {
    const fetchAllemployee = async () => {
      const empdata = {
        UserId: UID,
        Date: new Date(),
      };
      try {
        const responses = await getShifEmployees(empdata);
        setEmployee(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchAllemployee();
  }, [UID, AddAttedenceData.Date]); // Add dependencies if needed (e.g., UID or AddAttedenceData.date)
  const handleemployeechange = (e) => {
    setSelectedEmployee(e);
    // setAddAttedenceData(e)
    setAddAttedenceData((prev) => ({
      ...prev,
      EmpId: e.value,
    }));
  };

  useEffect(() => {
    const departmentname = department?.find(
      (el) => el.Id === DepartmentId
    )?.Name;
    setShowDepName(departmentname || "");
  }, [department]);

  useEffect(() => { }, [showDepName]);
  const [autheriseid, setautheriseid] = useState("");
  const handleButtonClick = (Id) => {
    setIsModalOpen(true); // Open the modal
    setautheriseid(Id);
  };

  const handleConfirm = () => {
    handleunautherise(autheriseid); // Call the unauthorize function
    setIsModalOpen(false); // Close the modal
  };

  const handleCancel = () => {
    setIsModalOpen(false); // Close the modal
    setautheriseid("");
  };
  const isAdmin = getSecureItem("IsAdmin");


  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
    setDate(currentDate);
  }, []);

  useEffect(() => {
    console.log("editingRowId", editingRowId);
  }, [editingRowId]);

  const fetchAttendenceRecords = async (selectedDate) => {
    const data = {
      Date: selectedDate,
      UserId: UID,
      DepartmentId: selectedDepartment.value,
    };
    try {
      setLoading(true);
      const response = await getAttendenceData(data);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter(
            (el) => el?.DEPARTMENTID == DepartmentId
          );

      console.log(details, "detailssss");

      setAttendenceRecords(details);
    } catch (error) {
      console.error("Error fetching attendance data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowClick = () => {
    fetchAttendenceRecords(date);
  };

  useEffect(() => {
    console.log("sds    AttendenceRecords", AttendenceRecords);
  }, [AttendenceRecords]);

  useEffect(() => {
    fetchAttendenceRecords(date);
  }, []);

  // const formatPunchTime = (time) => {
  //   // If time is already in HH:mm format, return as-is
  //   if (/^\d{2}:\d{2}$/.test(time)) return time;

  //   // If time is in ISO datetime format, extract time part
  //   const date = new Date(time);
  //   return date.toLocaleTimeString("en-US", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: false,
  //   });
  // };

  const handleApprove = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        UserId: UID,
        AttendenceRecords: AttendenceRecords.map((record) => ({
          ...record,
          ID: record.ID == null ? "" : record.ID,
          ATTENDANCESTATUS: selectedRows.includes(record.ID)
            ? 2
            : record.ATTENDANCESTATUS === 2
              ? 1
              : record.ATTENDANCESTATUS,
        })),
      };

      const response = await insertMarkAttendence(data);
      if (response.data.data.StatusCode === 200) {
        toast.success("Records submitted successfully");
        fetchAttendenceRecords(date);
      }
    } catch (error) {
      console.error("Error approving attendance:", error);
    } finally {
      setLoading(false);
      setEditingRowId(null);
    }
  };
  const handleunautherise = async (id) => {
    console.log("id", id);
    const data = {
      UserId: UID,
      Id: id,
    };

    const response = await unautheriseatttendance(data);
    if (response.data.data) {
      toast.success("Attendance Unautherised successfully ");
      fetchAttendenceRecords(date);
    } else {
      // toast.error(err)
      console.log("err", response);
    }
  };

  const handleTimeChange = (id, field, timeValue) => {
    const updatedData = AttendenceRecords.map((item) =>
      item.ID === id ? { ...item, [field]: timeValue } : item
    );

    setAttendenceRecords(updatedData);
    console.log(updatedData, "dfghjk");

    setEditingRowId(false);
  };

  const handleCancelEdit = () => {
    setShowModal(false); // Close the modal without saving
  };
  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    console.log(checked, "ssd");

    setAttendenceRecords((prevRecords) =>
      prevRecords.map((record) =>
        record.ATTENDANCESTATUS === 1
          ? record // Keep the record unchanged if ATTENDANCESTATUS is 1
          : {
            ...record,
            ATTENDANCESTATUS: checked ? 2 : 0, // Update only if ATTENDANCESTATUS is not 1
          }
      )
    );
  };

  const handleSaveTime = (editingRow) => {
    console.log(editingRow,'gfgfgfg');

    if (!newInTime || !newOutTime) return; // Ensure valid times are provided

    setAttendenceRecords((prevRecords) =>
      prevRecords.map((record) => {
        console.log(editingRow,'gfgfgfg');
        
        if (record.ID === editingRow.id) {
          const inDatePart = record.INTIME.split("T")[0]; // Extract date part of InTime
          const outDatePart = record.OUTTIME.split("T")[0]; // Extract date part of OutTime
          return {
            ...record,
            INTIME: `${inDatePart}T${newInTime}:00.000Z`, // Combine date and new InTime
            OUTTIME: `${outDatePart}T${newOutTime}:00.000Z`, // Combine date and new OutTime
            SHIFTID: newshif,
            DEPARTMENTID: newdep,
          };
        }
        return record;
      })
    );

    setShowModal(false); // Close the modal
    setNewInTime(""); // Clear the time input
    setNewOutTime(""); // Clear the time input
  };


  const handleFilter = (filteredResults) => {
    setAttendenceRecords(filteredResults); // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const [addAttendenceModal, setAddAttendenceModal] = useState(false);

  // const [employeeshift, setEmployeebyShift] = useState("");



  const openAddAttendenceModal = () => {
    setAddAttedenceData({});
    setAddAttendenceModal(!addAttendenceModal);
  };

  const fetchShifts = async () => {
    setLoading(true);
    try {
      const response = await getShift(UID); // Call the API
      setShifs(response.data.data); // Update state with fetched data
      console.log(shift, "Fetched data");
    } catch (error) {
      console.error("Error fetching shifts", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchShifts();
  }, []);

  useEffect(() => {
    console.log("shift", shift);
  });

  const [selectedShift, setSelectedShift] = useState("");

  // Utility function to extract time in HH:mm format
  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toISOString().slice(11, 16); // Extract HH:mm
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // When the shift is selected, update InTime and OutTime based on the shift's StartTime and EndTime
    if (name === "Shift") {
      const selectedShift = shift.find((shiftItem) => shiftItem.Id === value);
      if (selectedShift) {
        setAddAttedenceData((prev) => ({
          ...prev,
          [name]: value,
          InTime: selectedShift.StartTime.split("T")[1].slice(0, 5), // Extract the time part of StartTime
          OutTime: selectedShift.EndTime.split("T")[1].slice(0, 5), // Extract the time part of EndTime
        }));
      }
    } else {
      setAddAttedenceData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true when the form submission starts
    console.log("Attendance Records:", AddAttedenceData);
    try {
      // Prepare the data for submission
      const data = {
        ...AddAttedenceData,
        UserId: UID, // Ensure UID is defined properly
        EmpployeeId: AddAttedenceData.EmpId,
        ATTENDANCESTATUS: 1,
        DeptId: DepartmentId,
      };
      // Make the API call to submit the data (inserting attendance)
      const response = await insetNewAttendence(data);
      if (response?.data?.message) {
        openAddAttendenceModal(false);
        fetchAttendenceRecords();
        toast.success("Attendance submitted successfully!");
      } else {
        toast.error("Failed to submit attendance. Please try again.");
      }
    } catch (error) {
      // Handle any errors that occur during the API call
      toast.error("An error occurred: " + error.message);
    } finally {
      // Set loading state to false after the submission attempt
      setLoading(false);
    }
  };

  const clearData = () => {
    setAddAttedenceData({
      Id: "",
      EmpId: "",
      Date: "",
      Shift: "",
      EmployeeName: "",
      InTime: "",
      OutTime: "",
    });
    setSelectedEmployee({});
  };



  const aggregatedData = AttendenceRecords.reduce((acc, record) => {
    const departmentName = department.find((el) => el.Id === record.DEPARTMENTID)?.Name || "N/A";

    const key = `${record.DEPARTMENTID}`; // Unique key for each department

    if (!acc[key]) {
      acc[key] = {
        DEPARTMENTID: record.DEPARTMENTID,
        DepartmentName: departmentName,
        EmployeeCount: 0,
      };
    }

    acc[key].EmployeeCount += 1; // Increment employee count for the department

    return acc;
  }, {});
  // Converting the aggregated object into an array
  const summaryData = Object.values(aggregatedData);

  const filteredRows = summaryData.filter((row) => {
    const rowData = [
      row.EmployeeName,
      row.ShiftName,
      row.DepartmentName,
      row.PUNCHIN,
      row.PUNCHOUT,
      row.ATTENDANCESTATUS === 1 ? "Approved" : "Pending", // Attendance Status
    ];
    return rowData?.some((data) => data?.toLowerCase().includes(filterText.toLowerCase()));
  });

  // Updated table columns
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredRows.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    // {
    //   name: "Shift Name",
    //   selector: (row) => row.ShiftName,
    //   sortable: true,
    // },
    {
      name: "Department",
      selector: (row) => row.DepartmentName,
      sortable: true,
    },
    {
      name: "Number of Employees",
      selector: (row) => row.EmployeeCount,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="btn btn-primary hover:bg-blue-600  rounded px-4 py-2"
          onClick={() => handleViewMore(row)}
        >
          View More
        </button>
      ),
    },
  ];
  const navigate = useNavigate();
  // Handle "View More" button click
  const handleViewMore = (row) => {
    // Logic to display detailed information about the selected row
    console.log("View More clicked for:", row);
    navigate("/DetailedAttendance", {
      state: {
        ...row, // Spread the existing row properties
        date: date, // Add the date property
      },
    });
  };

  return (
    <>
      <div className="flex items-center justify-between mb-8">
        <div>
          {/* <p className="ms-5">User Department is : {showDepName}</p> */}
          <Breadcrumb title="Attendance" />
        </div>
        {/* Action Area */}
        {AttendenceRecords.length > 0 ? (
          <div className="flex items-center gap-4">
            {/* Search and Clear Buttons */}
            <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
              <button
                className="bg-sky rounded-[4px] px-10 py-[8px]"
                onClick={handleFilterClick}
              >
                <IconFilter className="text-white w-[18px] h-[18px]" />
              </button>
              <div className="relative">
                <input
                  type="text"
                  id="search"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                  placeholder="Search by Department"
                  className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <button onClick={handleClear} className="btn btn-danger">
                Clear
              </button>
            </div>

            {/* Add New Button */}
          </div>
        ) : (
          ""
        )}
      </div>
      {showModal && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.content}>
            <div className="flex flex-col gap-4 ">
              <div>
                <label htmlFor="inTime">In Time:</label>
                <input
                  id="inTime"
                  type="time"
                  value={newInTime}
                  onChange={(e) => setNewInTime(e.target.value)}
                  style={modalStyles.inputField}
                />
              </div>

              <div>
                <label htmlFor="outTime">Out Time:</label>
                <input
                  id="outTime"
                  type="time"
                  value={newOutTime}
                  onChange={(e) => setNewOutTime(e.target.value)}
                  style={modalStyles.inputField}
                />
              </div>
              <div className="form-group flex col-span-12 flex-col">
                <label>
                  Shift
                </label>
                <select
                  id="shift"
                  name="Shift"
                  value={newshif}
                  onChange={(e) => setnewshif(e.target.value)}
                >
                  <option value="">Select Shift</option>
                  {shift
                    .filter(
                      (el) =>
                        !AttendenceRecords.some(
                          (record) =>
                            record.EMPLOYEEID === newemp &&
                            record.SHIFTID === el.Id
                        )
                    )
                    .map((el) => (
                      <option key={el.Id} value={el.Id}>
                        {el.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="form-group flex col-span-12 flex-col mb-2">
                <label>
                  Department <span style={{ color: "red" }}></span>
                </label>
                <select
                  id="Department"
                  name="Department"
                  value={newdep}
                  onChange={(e) => setnewdep(e.target.value)}
                >
                  <option value="">Select Department</option>
                  {department.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div
              className="modal-actions"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                style={{
                  ...modalStyles.button,
                  ...modalStyles.saveButton,
                }}
                onClick={handleSaveTime}
                onMouseOver={(e) =>
                (e.target.style.backgroundColor =
                  modalStyles.saveButtonHover.backgroundColor)
                }
                onMouseOut={(e) =>
                (e.target.style.backgroundColor =
                  modalStyles.saveButton.backgroundColor)
                }
              >
                Save
              </button>
              <button
                style={{
                  ...modalStyles.button,
                  ...modalStyles.cancelButton,
                }}
                onClick={handleCancelEdit}
                onMouseOver={(e) =>
                (e.target.style.backgroundColor =
                  modalStyles.cancelButtonHover.backgroundColor)
                }
                onMouseOut={(e) =>
                (e.target.style.backgroundColor =
                  modalStyles.cancelButton.backgroundColor)
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={AttendenceRecords}
          onFilter={handleFilter}
        />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="flex justify-between w-full">
          <div className="p-4 gap-4">
            <label
              htmlFor="date-input"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Select Date
            </label>
            <input
              type="date"
              id="date-input"
              className="w-[400px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
              value={date?new Date(date).toISOString().split("T")[0]:""}
              onChange={handleDateChange}
              max={new Date().toISOString().split("T")[0]} // Disable future dates

            />

            <button className="btn btn-success ml-4" onClick={handleShowClick}>
              Show
            </button>
            {isAdmin == 1 &&
              ""
              // <div>
              //   <label htmlFor="options" className="block text-lg font-medium mb-2">Select Department</label>
              //   {/* <select name="options" id="options" className="w-full max-w-xs p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              //     <option value="">Choose Department</option>
              //     {department.map((el) => (
              //       <option value="option2">{el.Name}</option>
              //     ))}

              //   </select> */}
              //   <Select
              //     options={departmentoption}
              //     value={selectedDepartment}
              //     onChange={(e) => { setSelectedDepartment(e) }}
              //   />
              // </div>
            }
          </div>

          {/* <button
            onClick={openAddAttendenceModal}
            className="btn btn-primary mt-5 ml-auto  w-[90px] h-[40px]"
          >
            Add New
          </button> */}
        </div>

        {AttendenceRecords?.length == 0 ? (
          ""
        ) : (
          <div>
            {/* <input
              type="checkbox"
              onChange={handleSelectAllChange}
              checked={AttendenceRecords.every(
                (record) =>
                  record.ATTENDANCESTATUS === 1 || record.ATTENDANCESTATUS === 2
              )} // Checks if all checkboxes are selected
            />{" "}
            Select All */}
          </div>
        )}

        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <ReactDataTable
              columns={columnsFilter}
              data={filteredRows}
              pagination
            />
          )}
        </div>
        {!loading &&
          (AttendenceRecords.length > 0 ? (
            <div className="w-full justify-end flex">
              {/* <button
                  onClick={handleApprove}
                  type="button"
                  className="btn btn-primary"
                >
                  Submit
                </button> */}
            </div>
          ) : null)}
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-[3px] z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-96">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Do you want to cancel the approve?
              </h2>
              <div className="flex justify-end gap-4">
                <button
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md px-4 py-2"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="bg-red-500 hover:bg-red-600 text-white rounded-md px-4 py-2"
                  onClick={handleConfirm}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {addAttendenceModal && (
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50">
            <>
              <form onSubmit={handleSubmit}>
                <div className="fixed p-15 w-full max-w-[600px]  left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
                  <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                    <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                      Add Attendance
                      <span className="absolute top-0 right-0">
                        <button
                          onClick={() => {
                            openAddAttendenceModal();
                          }}
                          className="btn flex items-center justify-center"
                        >
                          ✖
                        </button>
                      </span>
                    </h5>
                    <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                      <div className="grid grid-cols-12 gap-20">
                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Date <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="date"
                            id="Date"
                            name="Date"
                            placeholder="Choose Date"
                            required
                            value={AddAttedenceData.Date}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Shift <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            id="shift"
                            name="Shift"
                            required
                            value={AddAttedenceData.Shift}
                            onChange={handleChange}
                          >
                            <option value="">Select Shift</option>
                            {shift.map((el) => (
                              <option key={el.Id} value={el.Id}>
                                {el.Name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Employee Name{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            options={employeeOption}
                            value={selectedEmployee}
                            // onChange={(e) => { setSelectedEmployee(e) }}
                            onChange={(e) => {
                              handleemployeechange(e);
                            }}
                          />
                        </div>

                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            In Time <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="Intime"
                            name="InTime"
                            placeholder="In Time"
                            required
                            value={AddAttedenceData.InTime}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Out Time <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="time"
                            id="OutTime"
                            name="OutTime"
                            placeholder="Time"
                            required
                            value={AddAttedenceData.OutTime}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                      <button
                        onClick={clearData}
                        type="button"
                        className="btn btn-outline-secondary"
                      >
                        Clear
                      </button>
                      <button className="btn btn-primary">
                        Add Attendance
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </>
          </div>
        )}
      </div>
    </>
  );
}
